<script>
/**
 * @overview 课时详情
 *
 * @author huojinzhao
 */

import mapUtils, { $http, $upload, $token, baseURISaas } from "@/utils";
import DetailElement from "./components/DetailElement.vue";
import DetailReview from "./components/DetailReview.vue";
import DetailPreview from "./components/DetailPreview.vue";

export default {
  name: "CourseDetail",

  components: {
    DetailElement,
    DetailReview,
    DetailPreview,
  },

  data: () => ({
    loading: {
      init: false,
      submit: false,
      prepareSubmit: false,
      coursewareSubmit: false,
    },

    data: null,

    visible: {
      review: false,
      preview: false,
    },
    assistStatus: {},
  }),

  computed: {
    courseID() {
      return Number(this.$route.params.id);
    },
    structure_id() {
      return Number(this.$route.params.structure_id);
    },
    isTest() {
      return window.location.hostname === "final-courseware-vue.caihonggou.com" || window.location.hostname === "localhost";
    },
  },

  created() {
    console.log("baseURISaas---", baseURISaas);
    this.init();

    this.initAssistStatus();
  },

  methods: {
    ...mapUtils("form", ["submit", "errorAlert"]),

    init() {
      this.loading.init = true;

      $http
        .get(`/course/show/${this.courseID}`)
        .then((res) => {
          this.data = res;
        })
        .finally(() => {
          this.loading.init = false;
        });
    },
    initAssistStatus() {
      fetch(`${baseURISaas}/Tutor/getLessonPreparationStatus`, {
        body: JSON.stringify({
          structure_id: `${this.courseID}`,
        }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then(response => response.json())
        .then((res) => {
          this.assistStatus = res;
          console.log(`状态===${JSON.stringify(this.assistStatus)}`);
        })
        .finally(() => {});
    },

    submit() {
      const url = `/course/release/${this.courseID}`;

      this.loading.submit = true;

      $http
        .post(url)
        .then(this.cancel)
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.submit = false;
        });
    },

    cancel() {
      this.$router.back();
    },

    importPrepare(file) {
      if (!this.checkExcel(file.name)) return;

      const url = `/preview/import/${this.courseID}`;

      this.loading.prepareSubmit = true;

      $upload
        .serverUpload(url, { file, key: "excel" })
        .then(() => {
          this.$message({
            type: "success",
            message: "预习部分导入成功！",
          });

          this.init();
        })
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.prepareSubmit = false;
        });
    },

    importCourse(file) {
      if (!this.checkExcel(file.name)) return;

      this.loading.coursewareSubmit = true;
      console.log(file.name);
      $upload
        .qiniuUpload(file)
        .then(({ url }) => {
          const data = {
            course_id: this.courseID,
            excel_url: url,
          };

          return $http.post("/packet", data);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "课中部分导入成功，处理时间较长，请等待！",
          });

          this.init();
        })
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.coursewareSubmit = false;
        });
    },

    checkExcel(fileName) {
      const result = fileName.endsWith(".xlsx");

      result || this.$form_errorAlert("请上传.xlsx格式的文件.");

      return result;
    },

    reviewEdit() {
      this.visible.review = true;
    },
    previewEdit() {
      this.visible.preview = true;
    },
    previewUpdate() {
      this.init();

      this.previewCancel();
    },

    previewCancel() {
      this.visible.preview = false;
    },

    reviewUpdate() {
      this.init();

      this.reviewCancel();
    },

    reviewCancel() {
      this.visible.review = false;
    },

    // 辅师备课内容
    prepareLesson() {
      // eslint-disable-next-line
      console.log(`this.courseID==` + this.courseID);
      this.$router.push({
        path: "/course/assist",
        query: { id: this.courseID },
      });

      // this.$router.push({
      //   path: '/course/list',
      // });
    },

    // 去编辑课程
    editCourse() {
      console.log("去编辑课程");
      const token = $token.get();
      const apiMap = {
        localhost: "https://final-courseware-api.caihonggou.com",
        "final-courseware-vue.caihonggou.com":
          "https://final-courseware-api.caihonggou.com",
        "final-courseware.aikaola.com":
          "https://final-courseware-api.aikaola.com",
      };
      let dev = "";
      if (
        apiMap[window.location.hostname] ===
        "https://final-courseware-api.aikaola.com"
      ) {
        dev = "formal";
      } else {
        dev = "test";
      }

      const param = {
        id: this.courseID,
        pattern: "edit",
        dev,
        name: this.data.name,
        title: this.data.title,
        courseware_status: this.data.courseware_status,
        theme_id: this.data.theme_id,
        themeValue: this.data.theme_name,
        token,
      };
      const paramString = this.jsonToEqualString(param);
      if (dev === "formal") {
        window.open(
          `https://course-editor-look.aikaola.com/Editor/index.html?${paramString}`,
          // `http://192.168.8.124:8081/?${paramString}`
        );
      } else {
        window.open(
          // `https://final-activity.caihonggou.com/courseLook/index.html?${paramString}`,

          `https://course-editor-look.caihonggou.com/Editor/index.html?${paramString}`,
          // `http://192.168.8.124:8081/?${paramString}`
        );
      }
    },

    // json转 var='edit'字符串
    jsonToEqualString(json) {
      const keys = Object.keys(json);
      console.log(keys);
      const values = Object.values(json);
      console.log(values);
      let valueString = "";
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index];
        valueString += `${keys[index]}=${json[keys[index]]}&`;
      }
      console.log(valueString);
      return valueString;
    },

    // 去预览课程
    previewCourse() {
      console.log("去预览课程");
      const token = $token.get();
      const apiMap = {
        localhost: "https://final-courseware-api.caihonggou.com",
        "final-courseware-vue.caihonggou.com":
          "https://final-courseware-api.caihonggou.com",
        "final-courseware.aikaola.com":
          "https://final-courseware-api.aikaola.com",
      };
      let dev = "";
      if (
        apiMap[window.location.hostname] ===
        "https://final-courseware-api.aikaola.com"
      ) {
        dev = "formal";
      } else {
        dev = "test";
      }
      const param = {
        id: this.courseID,
        pattern: "preview",
        role: "teacher",
        theme_id: this.data.theme_id,
        dev,
        token,
      };
      const paramString = this.jsonToEqualString(param);
      if (dev === "formal") {
        window.open(
          `https://course-editor-look.aikaola.com/Look/index.html?${paramString}`,
          // `http://192.168.8.124:8081/?${paramString}`
        );
      } else {
        window.open(
          // `https://final-activity.caihonggou.com/courseLook/index.html?${paramString}`,

          `https://course-editor-look.caihonggou.com/Look/index.html?${paramString}`,
          // `http://192.168.8.124:8081/?${paramString}`
        );
      }
    },
    previewCocos() {
      // this.$router.push(`/course_preview/${this.courseID}/${this.data.theme_id}`);
      this.$router.push(`/course_preview/${this.courseID}/${this.data.theme_id}`);
    },
  },
};
</script>

<template>
  <div
    v-loading="loading.init"
    class="course-detail">
    <div
      v-if="data"
      class="course-detail__body">
      <ol class="course-detail__info">
        <li>
          <span>课程名称：{{ data.structure_name }}</span>
          <span>课时名称：{{ data.name }}</span>
          <span>课时标题：{{ data.title }}</span>
        </li>
        <li>
          <span>课件场景：{{ data.theme_name }}</span>
        </li>
        <li>
          <span>教学知识点：{{ data.knowledge_content }}</span>
        </li>
        <li>
          <span>创建时间：{{ data.create_date }}</span>
          <span>更新时间：{{ data.update_date }}</span>
        </li>
      </ol>

      <div
        class="course-detail__elements"
        style="width:100%">
        <DetailElement
          :status-type="assistStatus.msg==='已完成'?2:1"
          :status-name="assistStatus.msg"
          label="辅师备课内容"
          class="course-detail__element"
          width="250px"
          types="edit"
          @edit="prepareLesson"
        />

        <DetailElement
          v-loading="loading.prepareSubmit"
          :status-name="data.preview_status_name"
          :status-type="data.preview_status"
          label="预习"
          class="course-detail__element"
          width="250px"
          types="import,edit"
          @import="importPrepare"
          @edit="previewEdit"
        />

        <DetailElement
          v-loading="loading.coursewareSubmit"
          :status-name="data.courseware_status_name"
          :status-type="data.courseware_status"
          label="课中"
          class="course-detail__element"
          width="250px"
          types="import,edit,preview"
          @import="importCourse"
          @edit="editCourse"
          @preview="previewCocos"
        />

        <!--<el-button-->
        <!--v-if="isTest"-->
        <!--@click="previewCocos">预览</el-button>-->

        <DetailElement
          :status-name="data.review_status_name"
          :status-type="data.review_status"
          label="复习"
          class="course-detail__element"
          width="250px"
          types="edit"
          @edit="reviewEdit"
        />
      </div>
    </div>

    <AppFormSubmit
      :submitting="loading.submit"
      class="layout-the-footer"
      @submit="submit"
      @cancel="cancel"
    />
    <el-dialog
      :visible="visible.preview"
      :show-close="false"
      top="5vh"
      title="预习编辑">
      <DetailPreview
        v-if="visible.preview"
        :id="courseID"
        @success="previewUpdate"
        @cancel="previewCancel"
      />
    </el-dialog>
    <el-dialog
      :visible="visible.review"
      :show-close="false"
      top="5vh"
      title="复习编辑">
      <DetailReview
        v-if="visible.review"
        :id="courseID"
        @success="reviewUpdate"
        @cancel="reviewCancel"
      />
    </el-dialog>
  </div>
</template>

<style lang="postcss">
.course-detail {
  //flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.course-detail__body {
  display: flex;
  flex-flow: column wrap;
  //flex-grow: 1;
  padding: 2em;
  line-height: 1.75em;
  color: var(--font-color-primary);
}

.course-detail__info span {
  margin-right: 2em;
}

.course-detail__elements {
  //flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.course-detail__element {
  display: flex;
  flex-direction: column;
  margin: 100px;
  border-radius: var(--bd-radius);
}

.course-detail__element > span {
  display: flex;
  align-items: center;
  justify-content: center;
}

.course-detail__element > span:first-of-type {
  font-size: 40px;
  flex-grow: 1;
}

.course-detail__element > span:last-of-type {
  font-size: 32px;
  height: 50px;
}

.course-detail__save {
  margin-left: auto;
  margin-right: 1em;
}
</style>
